import classnames from 'classnames';
import type React from 'react';

import '@/workchat/v3/components/NewChannel/ChannelNameInput/ChannelNameInput.scss';

interface ChannelNameInputProps {
  autoFocus?: boolean;
  value: string;
  onChange: (value: string) => void;
  error: string | null;
  disabled?: boolean;
}

export default function ChannelNameInput({
  autoFocus,
  value,
  onChange,
  error,
  disabled = false,
}: ChannelNameInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="ChannelNameInput">
      <input
        data-testid="channel-name-input"
        // biome-ignore lint/a11y/noAutofocus: autofocus is required
        autoFocus={autoFocus}
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Enter channel name..."
        disabled={disabled}
        className={classnames('channel-name-input', {
          'has-error': !!error,
        })}
      />
      {error && (
        <div data-testid="channel-name-error" className="input-error">
          {error}
        </div>
      )}
    </div>
  );
}
